// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-ManageTBHotels-styles___h1--aioUy {
  text-align: left;
}

.pages-ManageTBHotels-styles___paper--w_NMJ {
  padding: 64px 40px 32px;
  padding-bottom: 0;
  border-radius: 0;
  box-shadow: none;
  border-top: none;
  border-left: none;
  border-right: none;
  background-color: transparent;
}

.pages-ManageTBHotels-styles___body--UcvEQ {
  padding-top: 30px;
  display: flex;
}

.pages-ManageTBHotels-styles___header--FAUK6 {
  text-align: left;
  padding-top: 30px;
}

.pages-ManageTBHotels-styles___header--FAUK6 h1 {
    margin: 0;
    font-family: 'Roboto';
    font-size: 40px;
    color: #1b2432;
    letter-spacing: 0;
  }
`, "",{"version":3,"sources":["webpack://./pages/ManageTBHotels/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AASnB;;AAPE;IACE,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB","sourcesContent":[".h1 {\n  text-align: left;\n}\n\n.paper {\n  padding: 64px 40px 32px;\n  padding-bottom: 0;\n  border-radius: 0;\n  box-shadow: none;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  background-color: transparent;\n}\n\n.body {\n  padding-top: 30px;\n  display: flex;\n}\n\n.header {\n  text-align: left;\n  padding-top: 30px;\n\n  h1 {\n    margin: 0;\n    font-family: 'Roboto';\n    font-size: 40px;\n    color: #1b2432;\n    letter-spacing: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"h1": `pages-ManageTBHotels-styles___h1--aioUy`,
	"paper": `pages-ManageTBHotels-styles___paper--w_NMJ`,
	"body": `pages-ManageTBHotels-styles___body--UcvEQ`,
	"header": `pages-ManageTBHotels-styles___header--FAUK6`
};
module.exports = ___CSS_LOADER_EXPORT___;
